import { render, staticRenderFns } from "./ResultVisibilitySettings.vue?vue&type=template&id=3c0bfb6c"
import script from "./ResultVisibilitySettings.vue?vue&type=script&lang=js"
export * from "./ResultVisibilitySettings.vue?vue&type=script&lang=js"
import style0 from "./ResultVisibilitySettings.vue?vue&type=style&index=0&id=3c0bfb6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports